/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportCreationInterval } from './ReportCreationInterval';
import {
    ReportCreationIntervalFromJSON,
    ReportCreationIntervalFromJSONTyped,
    ReportCreationIntervalToJSON,
    ReportCreationIntervalToJSONTyped,
} from './ReportCreationInterval';
import type { ReportConfigLayoutRepresentation } from './ReportConfigLayoutRepresentation';
import {
    ReportConfigLayoutRepresentationFromJSON,
    ReportConfigLayoutRepresentationFromJSONTyped,
    ReportConfigLayoutRepresentationToJSON,
    ReportConfigLayoutRepresentationToJSONTyped,
} from './ReportConfigLayoutRepresentation';
import type { ReportReferenceDate } from './ReportReferenceDate';
import {
    ReportReferenceDateFromJSON,
    ReportReferenceDateFromJSONTyped,
    ReportReferenceDateToJSON,
    ReportReferenceDateToJSONTyped,
} from './ReportReferenceDate';

/**
 * 
 * @export
 * @interface ReportConfigUpdateRequest
 */
export interface ReportConfigUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportConfigUpdateRequest
     */
    reportType?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigUpdateRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigUpdateRequest
     */
    subtitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReportConfigUpdateRequest
     */
    createAutomatically?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReportConfigUpdateRequest
     */
    createAt?: number;
    /**
     * 
     * @type {ReportCreationInterval}
     * @memberof ReportConfigUpdateRequest
     */
    creationInterval?: ReportCreationInterval;
    /**
     * 
     * @type {ReportReferenceDate}
     * @memberof ReportConfigUpdateRequest
     */
    referenceDate?: ReportReferenceDate;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportConfigUpdateRequest
     */
    sentToEmail?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigUpdateRequest
     */
    layoutGenerationPolicy?: string;
    /**
     * 
     * @type {Array<ReportConfigLayoutRepresentation>}
     * @memberof ReportConfigUpdateRequest
     */
    layouts?: Array<ReportConfigLayoutRepresentation>;
    /**
     * 
     * @type {boolean}
     * @memberof ReportConfigUpdateRequest
     */
    storeInDocuments?: boolean;
    /**
     * The ISO 639 code for the language of the report
     * @type {string}
     * @memberof ReportConfigUpdateRequest
     */
    language?: string;
}



/**
 * Check if a given object implements the ReportConfigUpdateRequest interface.
 */
export function instanceOfReportConfigUpdateRequest(value: object): value is ReportConfigUpdateRequest {
    return true;
}

export function ReportConfigUpdateRequestFromJSON(json: any): ReportConfigUpdateRequest {
    return ReportConfigUpdateRequestFromJSONTyped(json, false);
}

export function ReportConfigUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportConfigUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reportType': json['reportType'] == null ? undefined : json['reportType'],
        'title': json['title'] == null ? undefined : json['title'],
        'subtitle': json['subtitle'] == null ? undefined : json['subtitle'],
        'createAutomatically': json['createAutomatically'] == null ? undefined : json['createAutomatically'],
        'createAt': json['createAt'] == null ? undefined : json['createAt'],
        'creationInterval': json['creationInterval'] == null ? undefined : ReportCreationIntervalFromJSON(json['creationInterval']),
        'referenceDate': json['referenceDate'] == null ? undefined : ReportReferenceDateFromJSON(json['referenceDate']),
        'sentToEmail': json['sentToEmail'] == null ? undefined : json['sentToEmail'],
        'layoutGenerationPolicy': json['layoutGenerationPolicy'] == null ? undefined : json['layoutGenerationPolicy'],
        'layouts': json['layouts'] == null ? undefined : ((json['layouts'] as Array<any>).map(ReportConfigLayoutRepresentationFromJSON)),
        'storeInDocuments': json['storeInDocuments'] == null ? undefined : json['storeInDocuments'],
        'language': json['language'] == null ? undefined : json['language'],
    };
}

export function ReportConfigUpdateRequestToJSON(json: any): ReportConfigUpdateRequest {
    return ReportConfigUpdateRequestToJSONTyped(json, false);
}

export function ReportConfigUpdateRequestToJSONTyped(value?: ReportConfigUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reportType': value['reportType'],
        'title': value['title'],
        'subtitle': value['subtitle'],
        'createAutomatically': value['createAutomatically'],
        'createAt': value['createAt'],
        'creationInterval': ReportCreationIntervalToJSON(value['creationInterval']),
        'referenceDate': ReportReferenceDateToJSON(value['referenceDate']),
        'sentToEmail': value['sentToEmail'],
        'layoutGenerationPolicy': value['layoutGenerationPolicy'],
        'layouts': value['layouts'] == null ? undefined : ((value['layouts'] as Array<any>).map(ReportConfigLayoutRepresentationToJSON)),
        'storeInDocuments': value['storeInDocuments'],
        'language': value['language'],
    };
}

